/**
 * Same-page ID links must not reload the page
 * Intercepts any in-page anchor click (e.g. #form, /current/path/#form), prevents reload, smooth-scrolls to the target.
 */
export function initHashLinks() {
  const norm = (p) => (p || '/').replace(/\/$/, '') || '/'
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]')
    if (!a?.href || a.target === '_blank' || a.rel === 'external') return
    if (!a.href.includes('#')) return
    try {
      const u = new URL(a.href)
      if (!u.hash || norm(u.pathname) !== norm(location.pathname)) return
      const el = document.getElementById(u.hash.slice(1))
      if (!el) return
      e.preventDefault()
      const top = el.getBoundingClientRect().top + window.pageYOffset - 76 // nav height
      window.scrollTo({ top, behavior: 'smooth' })
      el.tabIndex = -1
      el.focus({ preventScroll: true })
      history.pushState('', '', location.pathname + location.search + u.hash)
    } catch (_) {}
  }, true)
}
